module.exports = __webpack_public_path__ + "static/media/chapter_number_2.df76b743.svg";